import instance from "../utils/network";

export interface AiRequest {
  hand: string[];
  flop: string[];
  turn: string | null;
  river: string | null;
  style: "aggressive" | "passive" | "balanced";
}

export interface AiResponse {
  reply: string;
  processingTime: number;
}
export function requestAi(request: AiRequest): Promise<AiResponse> {
  return instance.post("/ai-server", request);
}
